module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = 252
// module chunks = 0